import { RefObject, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { CherryViewer } from '@metavrse-inc/metavrse-lib';
import { FormikProps } from 'formik';

import viewerHelpers from 'atoms/helpers/viewer/viewer.helpers';

import { PublishedProjectErrors } from './errors';

const sleep = (m: number) => new Promise(r => setTimeout(r, m));

export const usePublishedProjectLogic = (
  canvas: RefObject<HTMLCanvasElement>,
  formRef: RefObject<FormikProps<{ password?: string }>>
) => {
  const params = useParams<{ id?: string }>();

  const [viewer, setViewer] = useState<CherryViewer>();
  const [error, setError] = useState<PublishedProjectErrors>();
  const [isDownloading, setIsDownloading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingPercentage, setLoadingPercentage] = useState(0);

  const loadProject = useCallback(
    async (password?: string) => {
      if (!viewer) return;

      if (!params.id) {
        setError(PublishedProjectErrors.PUBLISH_NOT_FOUND);
      }

      const url = `${process.env.API_BASE_URL}/file-server/publications/${params.id}`;

      await viewer.ProjectManager.loadNewURL(url, password, {
        onDownloadProgress: ({ loaded, total }) => {
          const percentage = Math.floor((loaded / total) * 100);
          setLoadingPercentage(percentage);
        },
        onIncorrectPassword: (password?: string) => {
          password &&
            formRef.current?.setErrors({
              password: 'Incorrect password',
            });
          setError(PublishedProjectErrors.INCORRECT_PASSWORD);
        },
        onLimitsExceeded: () => {
          setError(PublishedProjectErrors.LIMITS_EXCEEDED);
        },
        onProjectLoaded: async () => {
          setIsDownloading(false);
          setIsLoading(true);
          let URLLoader = {
            percentage: 0,
            zips: new Map(),
            close: ()=>{},
          }
          viewer.ProjectManager.URLLoader = URLLoader;
          while (!viewer.ProjectManager.launched){
            await sleep(16);
            if (viewer.ProjectManager.project?.data?.title != undefined){
              document.title = viewer.ProjectManager.project?.data?.title;
            }

            setLoadingPercentage(Math.round(URLLoader.percentage * 100));

            // if (URLLoader.zips.size > 0){
            //   let perc = 0;
            //   for (var [k, p] of URLLoader.zips){
            //     perc+=p;
            //   }
  
            //   perc = (perc / URLLoader.zips.size) * 100
  
            //   setLoadingPercentage(Math.round(perc));

            // }
          }

          setIsLoading(false);
        },
        onProjectNotFound: () => {
          setError(PublishedProjectErrors.PUBLISH_NOT_FOUND);
        },
        onProjectLoadingStart: () => {
          setError(undefined);
          setIsDownloading(true);
        },
        onProjectFileInvalid: () => {
          setError(PublishedProjectErrors.PUBLISH_INVALID);
        },
      });
    },
    [viewer]
  );

  useEffect(() => {
    const getViewer = async () => {
      if (!canvas.current) return;
      const viewer = await viewerHelpers.createViewer3DInstance(canvas.current);

      setViewer(viewer);
    };

    getViewer();
  }, [canvas]);

  useEffect(() => {
    loadProject();
  }, [viewer]);

  return {
    error,
    isLoading,
    isDownloading,
    loadingPercentage,
    loadProject,
    formRef,
  };
};
